import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PostAddIcon from '@mui/icons-material/PostAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DropzoneArea from 'react-dropzone-uploader';
import MultipleSelectAutocomplete from './MultipleSelectAutocomplete';
import { FileUploadCreate } from './FileUploadSection';
import { ServiceLaborSection } from './ServiceLaborSection';
import { makeStyles } from '@mui/styles';
import { base64Reader } from 'src/utils/storage/StrPhoto';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  FormControl,
  TextField,
  Divider,
  IconButton,
  Button
} from '@material-ui/core';
import { Fab } from '@mui/material';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  fileItem: {
    border: '1px solid #ccc',
    padding: 2,
    borderRadius: 2,
    marginBottom: 2
  },
  gridBars: {
    padding: 4,
    marginTop: 5
  }
}));

const SessionUser = getUser();

const createFileObject = id => ({
  id,
  fileType: 0,
  fileName: '',
  fileSize: 0,
  fileData: null,
  fileDataType: '',
  fileSystem: 0,
  fileLastModifiedDate: '',
  fileDataSize: 0,
  active: 1,
  fromDb: 0
});

const createHizmetIscilikObject = (id, hizmetler, iscilikler) => ({
  id,
  hizmetler,
  iscilikler,
  active: 1
});

function ProjectCreateV2({
  data,
  setData,
  projectFiles,
  setProjectFiles,
  errors,
  setErrors,
  projectHizmetlerIscilikler,
  setProjectHizmetlerIscilikler
}) {
  const [durum, setDurum] = React.useState([]);
  const [merkeziKlima, setMerkemziKlima] = React.useState([]);
  const [fileTypes, setFileTypes] = React.useState([]);
  const [hizmetler, setHizmetler] = React.useState([]);
  const [iscilikler, setIscilikler] = React.useState([]);
  const classes = useStyles();

  useEffect(() => {
    try {
      const mainArray = JSON.parse(
        localStorage.getItem('HavcComboData').replace(/\\"/g, '"')
      );
      setDurum(mainArray[0].DURUM);
      setMerkemziKlima(mainArray[0].MERKEZI_KLIMALAR);
      setFileTypes(mainArray[0].DOSYA_TIPLERI);
      setHizmetler(mainArray[0].HIZMETLER);
      setIscilikler(mainArray[0].ISCILIKLER);
    } catch {
      console.log('Bir hata oluştu.');
    }
  }, []);

  const getLabel = (pID, currentLevel, i) => {
    const index = data.filter(x => x.Level === currentLevel).length + i;

    switch (currentLevel) {
      case 0:
        return `Merkezi Kumanda-${parseInt(index) + 1}`;
      case 1:
        return `Sistem-${parseInt(index) + 1}`;
      case 2:
        return `ODU-${parseInt(index) + 1}`;
      case 3:
        return `IDU-${parseInt(index) + 1}`;
      default:
        return `Label-${index + 1}`;
    }
  };

  const getAccordionStyles = () => ({
    border: '1px solid #494747',
    borderRadius: '4px',
    marginBottom: '8px',
    marginTop: '8px'
  });

  const handleChange = (id, property, value, type) => {
    setData(prevItems =>
      prevItems.map(item => {
        if (item.Id === id || item.DerivationFrom === id) {
          let updatedItem = { ...item };
          if (type === 'auto') {
            updatedItem[property] = value ? value.Id : 0;
          } else if (type === 'text') {
            updatedItem[property] = value;
            if (
              property === 'AdditionalGasAmount' ||
              property === 'PreGasAmount'
            ) {
              const additionalGas =
                property === 'AdditionalGasAmount'
                  ? value
                  : item.AdditionalGasAmount;
              const preGas =
                property === 'PreGasAmount' ? value : item.PreGasAmount;
              updatedItem.SystemTotalGas =
                Math.round(
                  (parseFloat(additionalGas) + parseFloat(preGas)) * 10
                ) / 10;
            }
          }
          return updatedItem;
        }
        return item;
      })
    );
  };

  const systemRepeat = (newValue, oldValue, item) => {
    if (newValue < oldValue) {
      const idsToDelete = data
        .filter(x => x.Level === item.Level && x.DerivationFrom === item.Id)
        .sort((a, b) => b.Id - a.Id)
        .slice(0, oldValue - newValue)
        .map(item => item.Id);

      idsToDelete.forEach(id => handleDelete(id));
    } else {
      const arrLength =
        newValue -
        data.filter(x => x.Level == item.Level && x.DerivationFrom === item.Id)
          .length;
      const newElementId =
        data && data.length > 0 ? Math.max(...data.map(item => item.Id)) : 0;
      const newObjects = Array.from(
        { length: parseInt(arrLength - 1) },
        (_, index) => ({
          AdditionalGasAmount: parseFloat(item.AdditionalGasAmount),
          AirRouterCount: item.AirRouterCount,
          BranchCollectorCount: item.BranchCollectorCount,
          Cable12_7mm: parseFloat(item.Cable12_7mm),
          Cable15_88mm: parseFloat(item.Cable15_88mm),
          Cable19_05mm: parseFloat(item.Cable19_05mm),
          Cable22_22mm: parseFloat(item.Cable22_22mm),
          Cable25_4mm: parseFloat(item.Cable25_4mm),
          Cable28_88mm: parseFloat(item.Cable28_88mm),
          Cable34_92mm: parseFloat(item.Cable34_92mm),
          Cable41_28mm: parseFloat(item.Cable41_28mm),
          Cable6_35mm: parseFloat(item.Cable6_35mm),
          Cable9_52mm: parseFloat(item.Cable9_52mm),
          CommissioningDate: item.CommissioningDate,
          ControlRoomModel: item.ControlRoomModel,
          ControlRoomModelNote: item.ControlRoomModelNote,
          Creator: SessionUser?.UserId ? SessionUser?.UserId : 0,
          DerivationFrom: item.Id,
          DryContactCount: item.DryContactCount,
          DxCount: item.DxCount,
          EevKitCount: item.EevKitCount,
          FdxBoxCount: item.FdxBoxCount,
          FisNo: item.FisNo,
          FreshAirDxCount: item.FreshAirDxCount,
          FrontPanelCount: item.FrontPanelCount,
          HrBoxCount: item.HrBoxCount,
          HydrocideCount: item.HydrocideCount,
          Id: newElementId + index + 1,
          IduCount: item.IduCount,
          IntegrationModuleCount: item.IntegrationModuleCount,
          KsCommunicationKitCount: item.KsCommunicationKitCount,
          KsDxCount: item.KsDxCount,
          Level: item.Level,
          LineStatus: 'N',
          Modifier: SessionUser?.UserId ? SessionUser?.UserId : 0,
          OduCount: item.OduCount,
          PreGasAmount: parseFloat(item.PreGasAmount),
          ProjectID: item.ProjectID,
          RemoteCount: item.RemoteCount,
          SystemCapacity: parseFloat(item.SystemCapacity),
          SystemControlRoomModel: item.SystemControlRoomModel,
          SystemName: getLabel(0, item.Level, index),
          SystemNote: item.SystemNote,
          SystemRepeatCount: item.SystemRepeatCount,
          SystemStatus: item.SystemStatus,
          SystemTotalGas: parseFloat(item.SystemTotalGas)
        })
      );

      setData(prev => [...prev, ...newObjects]);
    }
  };
  const handleDelete = parentId => {
    const deleteNode = id => {
      setData(prevData => prevData.filter(item => item.Id !== id));
      const children = data.filter(item => item.DerivationFrom === id);
      children.forEach(child => deleteNode(child.Id));
    };

    const parentNode = data.find(item => item.Id === parentId);
    if (parentNode) {
      deleteNode(parentId);
    }
  };

  const handleAddFile = () => {
    const newFile = createFileObject(projectFiles.length + 1);
    setProjectFiles([...projectFiles, newFile]);
  };

  const handleAddHizmetIscilik = () => {
    const newFile = createHizmetIscilikObject(
      projectHizmetlerIscilikler.length + 1,
      [],
      []
    );
    setProjectHizmetlerIscilikler([...projectHizmetlerIscilikler, newFile]);
  };

  const handleHizmetlerChange = (id, selectedHizmetler) => {
    setProjectHizmetlerIscilikler(prev =>
      prev.map(file =>
        file.id === id ? { ...file, hizmetler: selectedHizmetler } : file
      )
    );
  };

  const handleIsciliklerChange = (id, selectedIscilikler) => {
    setProjectHizmetlerIscilikler(prev =>
      prev.map(file =>
        file.id === id ? { ...file, iscilikler: selectedIscilikler } : file
      )
    );
  };

  const handleFiles = async (newFiles, Id) => {
    let base64Result = '';
    base64Result = await base64Reader(newFiles.file);

    const updatedFiles = projectFiles.map(file => {
      if (file.id === Id) {
        return {
          ...file,
          fileName: newFiles.file.name,
          fileData: base64Result,
          fileDataType: newFiles.file.type,
          fileDataSize: newFiles.file.size,
          fileBindedSystems: newFiles.file.systemId,
          fileLastModifiedDate: newFiles.file.lastModifiedDate,
          active: file.active,
          fromDb: file.fromDb
        };
      }
      return file;
    });

    setProjectFiles(updatedFiles);
  };

  return (
    <React.Fragment>
      <Accordion key={'PD'} style={getAccordionStyles()}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ width: '33%', flexShrink: 0 }}>
            Proje Dağılımı
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {/* Merkezi Kumanda Creation */}
              {data.filter(item => item.Level === 0).length > 0 ? (
                <Accordion key={'MK'} style={getAccordionStyles()}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ width: '33%', flexShrink: 0 }}>
                      Merkezi Kumanda Bilgisi
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      {data
                        .filter(x => x.Level === 0)
                        .map(item => (
                          <React.Fragment key={item.Id}>
                            <Grid item xs={4}>
                              <FormControl fullWidth>
                                <Autocomplete
                                  id="ControlRoomModel"
                                  name="ControlRoomModel"
                                  fullWidth
                                  options={merkeziKlima}
                                  value={
                                    merkeziKlima.find(
                                      x => x.Id === item.ControlRoomModel
                                    ) || null
                                  }
                                  onChange={(event, value) =>
                                    handleChange(
                                      item.Id,
                                      'ControlRoomModel',
                                      value,
                                      'auto'
                                    )
                                  }
                                  getOptionLabel={option =>
                                    option.Dsc ? option.Dsc : ''
                                  }
                                  renderInput={params => (
                                    <TextField
                                      {...params}
                                      label="Merkezi Kumanda Modeli"
                                      variant="outlined"
                                    />
                                  )}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item xs={8}>
                              <FormControl fullWidth>
                                <TextField
                                  id="ControlRoomModelNote"
                                  name="ControlRoomModelNote"
                                  variant="outlined"
                                  multiline
                                  minRows={1}
                                  placeholder="Açıklama"
                                  value={item.ControlRoomModelNote}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'ControlRoomModelNote',
                                      event.target.value,
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                          </React.Fragment>
                        ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : (
                <></>
              )}
            </Grid>

            {/* Boru Metraj ve Gaz Creation */}
            <Grid item xs={12}>
              {data.filter(x => x.Level === 1).length > 0 ? (
                <Accordion key={'BG'} style={getAccordionStyles()}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ width: '33%', flexShrink: 0 }}>
                      Boru Metraj ve Gaz Miktarı
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid item xs={12}>
                      {data
                        .filter(x => x.Id === 1)
                        .map(item => (
                          <React.Fragment key={item.Id}>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    id="Cable6_35mm"
                                    name="Cable6_35mm"
                                    label="6.35 mm"
                                    type="number"
                                    variant="outlined"
                                    value={item.Cable6_35mm}
                                    onChange={event =>
                                      handleChange(
                                        item.Id,
                                        'Cable6_35mm',
                                        parseFloat(event.target.value),
                                        'text'
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    id="Cable9_52mm"
                                    name="Cable9_52mm"
                                    label="9.52 mm"
                                    type="number"
                                    variant="outlined"
                                    value={item.Cable9_52mm}
                                    onChange={event =>
                                      handleChange(
                                        item.Id,
                                        'Cable9_52mm',
                                        parseFloat(event.target.value),
                                        'text'
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    id="Cable12_7mm"
                                    name="Cable12_7mm"
                                    label="12.7mm"
                                    type="number"
                                    variant="outlined"
                                    value={item.Cable12_7mm}
                                    onChange={event =>
                                      handleChange(
                                        item.Id,
                                        'Cable12_7mm',
                                        parseFloat(event.target.value),
                                        'text'
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    id="Cable15_88mm"
                                    name="Cable15_88mm"
                                    label="15.88 mm"
                                    type="number"
                                    variant="outlined"
                                    value={item.Cable15_88mm}
                                    onChange={event =>
                                      handleChange(
                                        item.Id,
                                        'Cable15_88mm',
                                        parseFloat(event.target.value),
                                        'text'
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    id="Cable19_05mm"
                                    name="Cable19_05mm"
                                    label="19.05 mm"
                                    type="number"
                                    variant="outlined"
                                    value={item.Cable19_05mm}
                                    onChange={event =>
                                      handleChange(
                                        item.Id,
                                        'Cable19_05mm',
                                        parseFloat(event.target.value),
                                        'text'
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    id="Cable22_22mm"
                                    name="Cable22_22mm"
                                    label="22.22 mm"
                                    type="number"
                                    variant="outlined"
                                    value={item.Cable22_22mm}
                                    onChange={event =>
                                      handleChange(
                                        item.Id,
                                        'Cable22_22mm',
                                        parseFloat(event.target.value),
                                        'text'
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    id="Cable25_4mm"
                                    name="Cable25_4mm"
                                    label="25.4 mm"
                                    type="number"
                                    variant="outlined"
                                    value={item.Cable25_4mm}
                                    onChange={event =>
                                      handleChange(
                                        item.Id,
                                        'Cable25_4mm',
                                        parseFloat(event.target.value),
                                        'text'
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    id="Cable28_88mm"
                                    name="Cable28_88mm"
                                    label="28.88 mm"
                                    type="number"
                                    variant="outlined"
                                    value={item.Cable28_88mm}
                                    onChange={event =>
                                      handleChange(
                                        item.Id,
                                        'Cable28_88mm',
                                        parseFloat(event.target.value),
                                        'text'
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    id="Cable34_92mm"
                                    name="Cable34_92mm"
                                    label="34.92 mm"
                                    type="number"
                                    variant="outlined"
                                    value={item.Cable34_92mm}
                                    onChange={event =>
                                      handleChange(
                                        item.Id,
                                        'Cable34_92mm',
                                        parseFloat(event.target.value),
                                        'text'
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    id="Cable41_28mm"
                                    name="Cable41_28mm"
                                    label="41.28 mm"
                                    type="number"
                                    variant="outlined"
                                    value={item.Cable41_28mm}
                                    onChange={event =>
                                      handleChange(
                                        item.Id,
                                        'Cable41_28mm',
                                        parseFloat(event.target.value),
                                        'text'
                                      )
                                    }
                                  />
                                </FormControl>
                              </Grid>
                            </Grid>
                          </React.Fragment>
                        ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : (
                <></>
              )}
            </Grid>

            <Grid item xs={12}>
              {/* Sistem Creation */}
              {data.filter(item => item.Level === 1).length > 0 ? (
                data
                  .filter(x => x.Level === 1 && x.DerivationFrom === 0)
                  .map(item => (
                    <Accordion
                      key={'System-' + item.Id}
                      style={getAccordionStyles()}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography sx={{ width: '33%', flexShrink: 0 }}>
                          {item.SystemName}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          <Grid item xs={8}>
                            <FormControl fullWidth>
                              <TextField
                                id="SystemName"
                                name="SystemName"
                                label="Sistem Adı"
                                variant="outlined"
                                multiline
                                minRows={1}
                                value={item.SystemName}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'SystemName',
                                    event.target.value,
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          {/* <Grid item xs={4}>
                            <FormControl fullWidth>
                              <Autocomplete
                                id="SystemControlRoomModel"
                                name="SystemControlRoomModel"
                                label="Sistem Merkezi Kumandası"
                                fullWidth
                                options={merkeziKlima}
                                getOptionLabel={option =>
                                  option.Dsc ? option.Dsc : ''
                                }
                                renderInput={params => (
                                  <TextField
                                    {...params}
                                    label="Merkezi Kumanda Modeli"
                                    variant="outlined"
                                  />
                                )}
                                onChange={(event, value) =>
                                  handleChange(
                                    item.Id,
                                    'SystemControlRoomModel',
                                    value,
                                    'auto'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid> */}
                          <Grid item xs={4}>
                            <FormControl fullWidth>
                              <TextField
                                id="SystemRepeatCount"
                                name="SystemRepeatCount"
                                label="Sistem Tekrar Sayısı"
                                type="number"
                                variant="outlined"
                                value={item.SystemRepeatCount}
                                onChange={event => {
                                  handleChange(
                                    item.Id,
                                    'SystemRepeatCount',
                                    event.target.value,
                                    'text'
                                  );
                                  systemRepeat(
                                    parseInt(event.target.value),
                                    parseInt(item.SystemRepeatCount),
                                    item
                                  );
                                }}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            <FormControl fullWidth>
                              <TextField
                                id="PreGasAmount"
                                name="PreGasAmount"
                                label="Ön Gaz Miktarı"
                                type="number"
                                variant="outlined"
                                value={item.PreGasAmount}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'PreGasAmount',
                                    parseFloat(event.target.value),
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            <FormControl fullWidth>
                              <TextField
                                id="AdditionalGasAmount"
                                name="AdditionalGasAmount"
                                label="Ek Gaz Miktarı"
                                type="number"
                                variant="outlined"
                                value={item.AdditionalGasAmount}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'AdditionalGasAmount',
                                    parseFloat(event.target.value),
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            <FormControl fullWidth>
                              <TextField
                                id="SystemCapacity"
                                name="SystemCapacity"
                                label="Sistem Kapasitesi"
                                type="number"
                                variant="outlined"
                                value={item.SystemCapacity}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'SystemCapacity',
                                     parseFloat(event.target.value),
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            <FormControl fullWidth>
                              <TextField
                                id="SystemTotalGas"
                                name="SystemTotalGas"
                                label="Sistem Toplam Gaz Miktarı"
                                type="number"
                                variant="outlined"
                                value={
                                  Math.round(
                                    (parseFloat(item.PreGasAmount) +
                                      parseFloat(item.AdditionalGasAmount)) *
                                      10
                                  ) / 10
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            <FormControl fullWidth>
                              <Autocomplete
                                id="SystemStatus"
                                name="SystemStatus"
                                label="Sistemin Durumu"
                                fullWidth
                                options={durum}
                                getOptionLabel={option =>
                                  option.Dsc ? option.Dsc : ''
                                }
                                renderInput={params => (
                                  <TextField
                                    {...params}
                                    label="Sistem Durumu"
                                    variant="outlined"
                                  />
                                )}
                                onChange={(event, value) =>
                                  handleChange(
                                    item.Id,
                                    'SystemStatus',
                                    value,
                                    'auto'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            <FormControl fullWidth>
                              <TextField
                                id="CommissioningDate"
                                name="CommissioningDate"
                                label="Devreye Alım Tarihi"
                                variant="outlined"
                                type="date"
                                InputLabelProps={{
                                  shrink: true,
                                  required: true
                                }}
                                value={item.CommissioningDate}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'CommissioningDate',
                                    event.target.value,
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                          {/* İç-Dış Ünite Bilgileri */}
                          <Grid item xs={12}>
                            <Accordion
                              key={item.SystemName + '-UN'}
                              style={getAccordionStyles()}
                            >
                              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography
                                  sx={{ width: '33%', flexShrink: 0 }}
                                >
                                  İç-Dış Ünite Bilgileri
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid item xs={12}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="OduCount"
                                          name="OduCount"
                                          label="ODU Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[`OduCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`OduCount${item.Id}`]
                                          }
                                          value={item.OduCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'OduCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="IduCount"
                                          name="IduCount"
                                          label="IDU Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[`IduCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`IduCount${item.Id}`]
                                          }
                                          value={item.IduCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'IduCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="HydrocideCount"
                                          name="HydrocideCount"
                                          label="Hidrokit Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[`HydrocideCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`HydrocideCount${item.Id}`]
                                          }
                                          value={item.HydrocideCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'HydrocideCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="KsDxCount"
                                          name="KsDxCount"
                                          label="KS Dx Adet"
                                          type="number"
                                          variant="outlined"
                                          value={item.KsDxCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'KsDxCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="RemoteCount"
                                          name="RemoteCount"
                                          label="Kumanda Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[`RemoteCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`RemoteCount${item.Id}`]
                                          }
                                          value={item.RemoteCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'RemoteCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="FreshAirDxCount"
                                          name="FreshAirDxCount"
                                          label="Taze Hava DX Adet"
                                          type="number"
                                          variant="outlined"
                                          value={item.FreshAirDxCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'FreshAirDxCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="FrontPanelCount"
                                          name="FrontPanelCount"
                                          label="Ön Panel Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[`FrontPanelCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`FrontPanelCount${item.Id}`]
                                          }
                                          value={item.FrontPanelCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'FrontPanelCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="HrBoxCount"
                                          name="HrBoxCount"
                                          label="HR Box Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[`HrBoxCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`HrBoxCount${item.Id}`]
                                          }
                                          value={item.HrBoxCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'HrBoxCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="IntegrationModuleCount"
                                          name="IntegrationModuleCount"
                                          label="Entegrasyon Modül Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[
                                              `IntegrationModuleCount${item.Id}`
                                            ]
                                          )}
                                          helperText={
                                            errors[
                                              `IntegrationModuleCount${item.Id}`
                                            ]
                                          }
                                          value={item.IntegrationModuleCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'IntegrationModuleCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="KsCommunicationKitCount"
                                          name="KsCommunicationKitCount"
                                          label="Ks Haberleşme Kit Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[
                                              `KsCommunicationKitCount${item.Id}`
                                            ]
                                          )}
                                          helperText={
                                            errors[
                                              `KsCommunicationKitCount${item.Id}`
                                            ]
                                          }
                                          value={item.KsCommunicationKitCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'KsCommunicationKitCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="EevKitCount"
                                          name="EevKitCount"
                                          label="Eev Kit Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[`EevKitCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`EevKitCount${item.Id}`]
                                          }
                                          value={item.EevKitCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'EevKitCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="FdxBoxCount"
                                          name="FdxBoxCount"
                                          label="FDX Kutu Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[`FdxBoxCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`FdxBoxCount${item.Id}`]
                                          }
                                          value={item.FdxBoxCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'FdxBoxCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="BranchCollectorCount"
                                          name="BranchCollectorCount"
                                          label="Branşman/Kolektör Adet"
                                          type="number"
                                          variant="outlined"
                                          value={item.BranchCollectorCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'BranchCollectorCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="AirRouterCount"
                                          name="AirRouterCount"
                                          label="Hava Yönlendirici Adet"
                                          type="number"
                                          variant="outlined"
                                          error={Boolean(
                                            errors[`AirRouterCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`AirRouterCount${item.Id}`]
                                          }
                                          value={item.AirRouterCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'AirRouterCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>

                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <FormControl fullWidth>
                              <TextField
                                id="SystemNote"
                                name="SystemNote"
                                variant="outlined"
                                multiline
                                minRows={3}
                                placeholder="Açıklama"
                                value={item.SystemNote}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'SystemNote',
                                    event.target.value,
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  ))
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      {/* Modern Dosya Ekleme Bölümü */}
      <FileUploadCreate
        projectFiles={projectFiles}
        setProjectFiles={setProjectFiles}
        fileTypes={fileTypes}
        data={data}
        handleFiles={handleFiles}
        handleAddFile={handleAddFile}
      />
      {/* Modern Hizmet ve İşçilik Bölümü */}
      <ServiceLaborSection
        projectHizmetlerIscilikler={projectHizmetlerIscilikler}
        setProjectHizmetlerIscilikler={setProjectHizmetlerIscilikler}
        hizmetler={hizmetler}
        iscilikler={iscilikler}
        handleAddHizmetIscilik={handleAddHizmetIscilik}
        handleHizmetlerChange={handleHizmetlerChange}
        handleIsciliklerChange={handleIsciliklerChange}
      />
    </React.Fragment>
  );
}

export default ProjectCreateV2;
